import { render } from "./MyTopics.vue?vue&type=template&id=c3c28494&scoped=true"
import script from "./MyTopics.vue?vue&type=script&lang=js"
export * from "./MyTopics.vue?vue&type=script&lang=js"

import "./MyTopics.vue?vue&type=style&index=0&id=c3c28494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3c28494"]])

export default __exports__